import { useQuery } from '@tanstack/react-query';

import { createQueryKeys } from '@/lib/query/query-keys';

import { fetchProfile } from '../api';

export const profileKeys = createQueryKeys('profiles');

export function useProfile(userId: string | undefined) {
  return useQuery({
    queryKey: profileKeys.detail(userId ?? 'anonymous'),
    queryFn: () => fetchProfile(userId ?? ''),
    enabled: userId !== undefined,
    staleTime: 5 * 60_000,
  });
}
